module.exports = __webpack_public_path__ + "static/media/profile-img.cb511cf4.jpg";